import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Col, Row, Typography } from 'antd';
import busksellerdetail from '@modules/Busk/Busk-Seller-Detail/services/busksellerdetail';
import { useParams } from 'react-router';

interface Props {
  formData: any;
}

const SignUpDate = ({ formData }: Props) => {
  const formatDate = formatDateTime(formData?.createdAt);
  const { id } = useParams<{ id: string }>();

  const handelExportExcel = async () => {
    const response =
      await busksellerdetail.exportAll(
        id
      );
    const outputFilename = `Seller_all_240406T9g6QGJSxyR.zip`;

    const url = URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div
      style={{
        padding: '1rem',
        backgroundColor: 'white',
        marginBottom: '2rem'
      }}
    >
      <Row>
        <Col flex={10} style={{ paddingTop: '5px' }}>
          가입일 {formatDate}
          <Typography.Text
            style={{
              background: '#2B2C51',
              padding: '.5rem 2rem',
              borderRadius: '1rem',
              color: 'white',
              marginLeft: '10px'
            }}
          >
            {formData?.state}
          </Typography.Text>
        </Col>
        <Col flex={0.1}>
          <Button style={{ color: 'gray' }} onClick={handelExportExcel}>
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpDate;
